'use client';

import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import type { SiteSettingsDto } from '@/lib/sanity/dto';

const SiteSettingsContext = createContext<SiteSettingsDto | null | undefined>(undefined);

const EMPTY_SITE_SETTINGS: SiteSettingsDto = {
    _id: 'siteSettings',
    _type: 'siteSettings',
    siteTitle: '',
    navigation: { main: [] },
    socialLinks: [],
    openingHours: [],
};

export function SiteSettingsProvider({
    settings,
    children,
}: {
    settings: SiteSettingsDto | null;
    children: ReactNode;
}) {
    return <SiteSettingsContext.Provider value={settings ?? null}>{children}</SiteSettingsContext.Provider>;
}

export function useSiteSettings(): SiteSettingsDto {
    const ctx = useContext(SiteSettingsContext);
    if (ctx === undefined) {
        throw new Error('useSiteSettings must be used within SiteSettingsProvider');
    }
    return ctx ?? EMPTY_SITE_SETTINGS;
}
